import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

export interface FilterData {
  type: string;
  personaliseFiltre: string;
  adresse: string;
  mois: string;
}

@Component({
  selector: 'app-send-filter',
  templateUrl: './send-filter.component.html',
  styleUrls: ['./send-filter.component.scss']
})
export class SendFilterComponent {

  @Output() filterChanged = new EventEmitter<FilterData>();

  formFiltre: FormGroup;

  typeRow = [
    { value: 'MAIL', label: 'Mail' },
    { value: 'SMS', label: 'Sms' }
  ];

  filtres = [
    { value: 'TOUT', label: 'Tout' },
    { value: 'CLIENT', label: 'Clients' },
    { value: 'PROSPECT', label: 'Prospects' },
    { value: 'LOCATAIRE', label: 'Locataires' },
    { value: 'PROPRIÉTAIRE', label: 'Bailleurs' },
    { value: 'DEFINIR', label: 'Définir le ou les adresse(s) mail(s)' }
  ];

  constructor(private fb: FormBuilder) {
    this.formFiltre = this.fb.group({
      type: ['MAIL'],
      personaliseFiltre: ['TOUT'],
      adresse: [null],
      mois: [null]
    });
  }

  onFilter(): void {
    this.filterChanged.emit(this.formFiltre.getRawValue());
  }

  get g() { return this.formFiltre.controls; }
}
